import PubSub from "underpub-js";

var Subfooter = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Subfooter',
	};

	$.extend(true, this.options, options);

};

Subfooter.prototype.init = function() {

	var self = this;

};

export default Subfooter;
